import React, { useState } from 'react';
import { ChevronDown, ChevronUp, ArrowRight } from 'lucide-react';

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="border-b border-gray-200">
      <button
        className="w-full py-6 flex justify-between items-center text-left"
        onClick={onClick}
      >
        <h3 className="text-lg font-semibold text-[#113262] pr-8">{question}</h3>
        <ChevronDown
          className={`w-5 h-5 text-[#F49611] transform transition-transform duration-200 ${isOpen ? 'rotate-180' : ''
            }`}
        />
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-6' : 'max-h-0'
          }`}
      >
        <p className="text-gray-600">{answer}</p>
      </div>
    </div>
  );
};

const PEFAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "What is the minimum investment requirement for PE?",
      answer: "Our private equity investments typically start from ₹5 crores, allowing investors to access institutional-quality PE opportunities while maintaining appropriate portfolio diversification."
    },
    {
      question: "How long is the typical investment horizon?",
      answer: "PE investments generally have a 5-7 year horizon, though some opportunities may have shorter or longer durations based on the investment strategy and exit opportunities."
    },
    {
      question: "How do you manage investment risks?",
      answer: "We employ a comprehensive risk management framework including thorough due diligence, diversification across sectors and stages, and active monitoring of portfolio companies."
    },
    {
      question: "What types of returns can investors expect?",
      answer: "While returns vary based on investment strategy and market conditions, we target IRR in the range of 20-25% over the investment period through a combination of operational improvements and strategic growth."
    }
  ];
  return (
    <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
      <div className="flex flex-col md:flex-row gap-16">
        <div className="md:w-1/3">
          <div className="sticky top-8">
            <div className="w-12 h-0.5 bg-[#F49611] mb-3"></div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">
              Common Questions About Private Equity
            </h2>
            <p className="text-gray-600 mb-8">
              Get answers to frequently asked questions about our private equity investments.
              For more detailed discussions, our investment experts are ready to help.
            </p>
            <a href="/meeting" className="flex items-center text-[#F49611] font-semibold hover:gap-2 transition-all">
              <span>Speak With An Expert</span>
              <ArrowRight className="w-5 h-5 ml-2" />
            </a>
          </div>
        </div>
        <div className="md:w-2/3">
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={index === openIndex}
              onClick={() => setOpenIndex(index === openIndex ? -1 : index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PEFAQ;